export interface Gehoerschutz {
	url: string;
	description: string;
	text: string;
}

export const gehoerschutz: Gehoerschutz[] = [
	{
		url: '../../img/marketing-gs-sowei-bilder-04-stichsaege.webp',
		description: 'marketing-gs-sowei-bilder-04-stichsaege',
		text: 'Gehörschutz ist heute wichtiger denn je – sowohl im Freizeitbereich als auch im Berufsleben. Besonders im Handwerk und in der Industrie setzen wir auf maßgeschneiderte Lösungen in Zusammenarbeit mit unserem Partner Hörluchs.',
	},
	{
		url: '../../img/marketing-gs-sowei-unlimited-konzert-bilder-05-paar-mit-gs-im-ohr.webp',
		description: 'marketing-gs-sowei-unlimited-konzert-bilder-05-paar-mit-gs-im-ohr',
		text: 'Im Fokus steht dabei immer die individuelle Anpassung: Anstelle klassischer "Mickey-Mäuse" bieten wir maßgefertigte Gehörschutzsysteme, die nicht nur besser sitzen, sondern auch im Alltag akzeptierter sind.',
	},
	{
		url: '../../img/marketing-gs-sowei-unlimited-musiker-bilder-03-eingesetzt.webp',
		description: 'marketing-gs-sowei-unlimited-musiker-bilder-03-eingesetzt',
		text: 'Auch in der Freizeit spielt angepasster Gehörschutz eine große Rolle – sei es beim Motorradfahren, bei lauter Musik, auf Festivals oder für einen ruhigen Schlaf. Hier ermöglichen Filterlösungen zum Beispiel eine Dämmung der Motor - oder Umweltgeräusche, lassen Sprache aber weiterhin verständlich zu.',
	},
	{
		url: '../../img/security-image.webp',
		description: 'security-image',
		text: 'Für Sicherheitskräfte oder Polizei bieten wir zudem Systeme mit integrierter Funkanbindung, die diskret, zuverlässig und gleichzeitig schützend wirken. Sollte bei einer Hörminderung eine Ansprechbarkeit auch im lauten Arbeitsumfeld notwendig sein, gibt es angepasste Lösungen die Gehörschutz und Sprachverstehen intelligent miteinander kombinieren.',
	},
];
